module.exports = __webpack_public_path__ + "static/Adfinas_LOGO-7a14110ddbdf27d333f3bf4e78b220f8.png";